import * as _ from 'lodash';

import { NewDefaultNavigationBtns } from '@/components/AdminContainer/navigationDefaults';
import type { NavigationOptions } from '@/models/Ou';

const navigationUtils = {
  compareToCustomerType(navigation: NavigationOptions, customerType: string) {
    // console.log('compareToCustomerType', { navigation, customerType });
    if (navigation == null) {
      return false;
    }
    const navigationCopy = _.cloneDeep(NewDefaultNavigationBtns);
    for (let i = 0; i < navigationCopy.length; i++) {
      const x = navigationCopy[i];
      if (x.value === 'divider') continue;
      if (x[customerType] !== navigation[x.value]) {
        // console.log(`compareToCustomerType ${customerType} failed at ${x.value}`);
        return false;
      }
      if (x.children && x.children.length > 0) {
        for (let j = 0; j < x.children.length; j++) {
          const child = x.children[j];
          if (child.value === 'divider') continue;
          if (child[customerType] !== navigation[child.value]) {
            // console.log(`compareToCustomerType ${customerType} failed at ${x.value}`);
            return false;
          }
        }
      }
    }
    return true;
  },

  getDefaultFeatures() {
    // console.log('getDefaultChannelFeatures');
    const defaultFeatures: NavigationOptions = {};
    const navigationCopy = _.cloneDeep(NewDefaultNavigationBtns);
    for (let i = 0; i < navigationCopy.length; i++) {
      const x = navigationCopy[i];
      defaultFeatures[x.value] = false;
      if (x.children && x.children.length > 0) {
        for (let j = 0; j < x.children.length; j++) {
          const child = x.children[j];
          defaultFeatures[child.value] = false;
        }
      }
    }
    return defaultFeatures;
  },

  getDefaultChannelFeatures() {
    // console.log('getDefaultChannelFeatures');
    const defaultFeatures: NavigationOptions = {};
    const navigationCopy = _.cloneDeep(NewDefaultNavigationBtns);
    for (let i = 0; i < navigationCopy.length; i++) {
      const x = navigationCopy[i];
      defaultFeatures[x.value] = x.channels;
      if (x.children && x.children.length > 0) {
        for (let j = 0; j < x.children.length; j++) {
          const child = x.children[j];
          defaultFeatures[child.value] = child.channels;
        }
      }
    }
    return defaultFeatures;
  },

  getDefaultAppsFeatures() {
    // console.log('getDefaultChannelFeatures');
    const defaultFeatures: NavigationOptions = {};
    const navigationCopy = _.cloneDeep(NewDefaultNavigationBtns);
    for (let i = 0; i < navigationCopy.length; i++) {
      const x = navigationCopy[i];
      if (x.apps === true) {
        defaultFeatures[x.value] = true;
      }
      if (x.children && x.children.length > 0) {
        for (let j = 0; j < x.children.length; j++) {
          const child = x.children[j];
          if (child.apps === true) {
            defaultFeatures[child.value] = true;
          }
        }
      }
    }
    return defaultFeatures;
  },
};

export default navigationUtils;
